import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcAlarm(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.158 12a7.25 7.25 0 1 0-14.5 0 7.25 7.25 0 0 0 14.5 0m-8-.368V7.556a.75.75 0 1 1 1.5 0v4.076q.001.057.04.098l2.407 2.407a.75.75 0 0 1-1.06 1.06l-2.407-2.406a1.64 1.64 0 0 1-.48-1.16m8.28-6.662a2.25 2.25 0 0 0-2.78-.318 8.8 8.8 0 0 1 2.985 3.258 2.25 2.25 0 0 0-.205-2.94M7.244 4.597A2.249 2.249 0 0 0 4.25 7.764a8.8 8.8 0 0 1 2.994-3.167M20.658 12a8.72 8.72 0 0 1-2.527 6.15l1.314 1.313a.75.75 0 0 1-1.06 1.06l-1.4-1.399a8.7 8.7 0 0 1-5.077 1.626 8.7 8.7 0 0 1-5.079-1.626l-1.398 1.4a.75.75 0 0 1-1.06-1.061l1.313-1.314A8.72 8.72 0 0 1 3.158 12c0-.947.151-1.858.43-2.712a1 1 0 0 1-.09-.076 3.75 3.75 0 0 1 5.236-5.366 8.7 8.7 0 0 1 3.174-.596c1.168 0 2.282.23 3.3.645a3.75 3.75 0 0 1 5.29 5.317.75.75 0 0 1-.243.161c.26.83.403 1.712.403 2.627"
  }));
}
var IcAlarm = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAlarm));

export { IcAlarm as I };
